import {useState} from "react";
import {CountryLimitsTab} from "./components/CountryLimitsTab";
import {LevelConfigsTab} from "./components/LevelConfigsTab";
import {PromotionConditionsTab} from "./components/PromotionConditionsTab";
import {UserLevelsTab} from "./components/UserLevelsTab";

type Tab = "users" | "configs" | "conditions" | "country-limits";

const TABS: {key: Tab; label: string}[] = [
  {key: "users", label: "Usuarios"},
  {key: "configs", label: "Configuración"},
  {key: "conditions", label: "Promoción"},
  {key: "country-limits", label: "Límites por País"},
];

export function Levels() {
  const [activeTab, setActiveTab] = useState<Tab>("users");

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold text-(--color-text-primary)">Niveles</h1>
        <p className="text-sm text-(--color-text-secondary) mt-1">
          Gestión de niveles de usuario, configuraciones, condiciones de promoción y límites por país.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 border-b border-(--color-border)">
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={[
              "px-4 py-2.5 text-sm font-medium transition-colors -mb-px border-b-2",
              activeTab === tab.key
                ? "border-(--color-primary) text-(--color-primary)"
                : "border-transparent text-(--color-text-secondary) hover:text-(--color-text-primary) hover:border-(--color-border)",
            ].join(" ")}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === "users" && <UserLevelsTab />}
      {activeTab === "configs" && <LevelConfigsTab />}
      {activeTab === "conditions" && <PromotionConditionsTab />}
      {activeTab === "country-limits" && <CountryLimitsTab />}
    </div>
  );
}
